import { render, staticRenderFns } from "./HuntingWordsEdit.vue?vue&type=template&id=91160cb6"
import script from "./HuntingWordsEdit.vue?vue&type=script&lang=js"
export * from "./HuntingWordsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports